import {grayColors} from "../../architecture/gray-colors";

export const baseColors = {
    base01: "#d62a8c",
    base01Contrast: "#ffffff",
    base01Dark: "#bc257b",
    base01Light: "#da3f98",

    base02: "#310a53",
    base02Contrast: "#ffffff",
    base02Dark: "#462365",
    base02Light: "#6d5c80",

    base03: "#ff014f",
    base03Contrast: "#ffffff",
    base03Dark: "#e00146",
    base03Light: "#ff1a61",


    base04: "#d5ec37",
    base04Contrast: "#180529",
    base04Dark: "#7aec37",
    base04Light: "#ffff00",

    ...grayColors
}